import ActionTypes from "./types";

export default () => {
  return {
    type: ActionTypes.RESET_COMMENTS_FOR_ME,
  };
};
